module.exports = __webpack_public_path__ + "web/img/test111.ff2e5c60.png";